export const bookingStatisticsKeys = {
  all: ['statistics'] as const,
  lists: () => [...bookingStatisticsKeys.all, 'list'] as const,
  list: (
    adminToken: string,
    from: string | null,
    to: string | null,
    variant: 'MONTHLY' | 'DAILY',
    types?: string[],
    floors?: number[],
  ) =>
    [
      ...bookingStatisticsKeys.lists(),
      adminToken,
      {
        from,
        to,
        variant,
        types,
        floors,
      },
    ] as const,
};
